// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Title__container-d47ff2 {
  max-width: var(--max-width-article-layout);
  display: flex;
  align-items: center;
  margin-inline-start: 48px;
}

.Title__left-block-fe9c03 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.Title__publish-f794e5 {
  margin-inline-end: 32px;
}

.Title__close-ef8f45 {
  margin: 0 20px 0 30px;
}

.Title__title-a53d3f {
  width: 100%;
  font: var(--font-title-5);
  letter-spacing: var(--font-spacing-title-5);
  color: var(--base-110);
  white-space: pre-wrap;
  word-break: break-word;
}

.Title__title-a53d3f:empty:before {
  color: var(--base-70);
  content: attr(placeholder);
  pointer-events: none;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/ArticleRedactor/Title/styles.m.css"],"names":[],"mappings":"AAAA;EACE,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AACF;;AAEA;EACE,qBAAA;EACA,0BAAA;EACA,oBAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  max-width: var(--max-width-article-layout);\n  display: flex;\n  align-items: center;\n  margin-inline-start: 48px;\n}\n\n.left-block {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.publish {\n  margin-inline-end: 32px;\n}\n\n.close {\n  margin: 0 20px 0 30px;\n}\n\n.title {\n  width: 100%;\n  font: var(--font-title-5);\n  letter-spacing: var(--font-spacing-title-5);\n  color: var(--base-110);\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.title:empty:before {\n  color: var(--base-70);\n  content: attr(placeholder);\n  pointer-events: none;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Title__container-d47ff2`,
	"left-block": `Title__left-block-fe9c03`,
	"leftBlock": `Title__left-block-fe9c03`,
	"publish": `Title__publish-f794e5`,
	"close": `Title__close-ef8f45`,
	"title": `Title__title-a53d3f`
};
module.exports = ___CSS_LOADER_EXPORT___;
